export type CompanyColorTheme = 'light' | 'dark';

// Deterministic, client-side per-company color. Same company id/name always
// maps to the same swatch (per theme) — nothing is persisted. A simple string
// hash picks a hue on the color wheel; saturation/lightness are fixed per
// theme so every label stays legible against its pill background — pale bg /
// dark text on the light surface, low-lightness bg / light text on the dark
// surface. Used by the Blueprints table's company column.
export function companyColor(seed: string, theme: CompanyColorTheme = 'light'): {bg: string; text: string} {
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
        hash = (hash * 31 + seed.charCodeAt(i)) | 0;
    }
    const hue = Math.abs(hash) % 360;
    return theme === 'dark'
        ? {bg: `hsl(${hue}, 45%, 22%)`, text: `hsl(${hue}, 70%, 78%)`}
        : {bg: `hsl(${hue}, 70%, 92%)`, text: `hsl(${hue}, 70%, 28%)`};
}
